const __DEV__ = false;

import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';

function useControlledState(controlledValue, defaultValue) {
  var controlledRef = React.useRef(controlledValue != null);
  var _React$useState = React.useState(defaultValue),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      valueState = _React$useState2[0],
      setValue = _React$useState2[1];
  var set = React.useCallback(function (n) {
    if (!controlledRef.current) {
      setValue(n);
    }
  }, []);
  return [controlledRef.current ? controlledValue : valueState, set];
}

export { useControlledState as default };
//# sourceMappingURL=use-controlled-state.js.map
